import styled, { css } from 'styled-components';
import { rtlFlip } from 'src/utils/theme';

export const InfoBubble = styled.button(
  ({ theme }) => css`
    margin-left: ${theme.sz.s3};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: ${theme.sz.s6};
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
    color: inherit;

    svg {
      transform: scaleX(${rtlFlip(theme)});
    }
  `,
);

export const Label = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: inherit;
  `,
);
